import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sortedIds: [],
  entities: {},
  filters: {},
  sorter: {},
  isLoaded: false,
  isSavingActive: false,
  search: '',
  page: 1,
  pageCount: 1,
}

const SEOPagesSlice = createSlice({
  name: 'SEOPages',
  initialState,
  reducers: {
    fetchSEOPagesSuccess: (state, { payload }) => ({
      ...state,
      isLoaded: true,
      page: payload.page,
      pageCount: payload.pageCount,
      entities: payload.product_families,
      sortedIds: payload.sortedIds,
    }),
    fetchSEOPagesFailure: (state) => state,
    resetFiltersAndSorter: (state) => ({
      ...state,
      page: initialState.page,
      filters: initialState.filters,
      sorter: initialState.sorter,
    }),
    saveFiltersAndSorter: (state, { payload = {} }) => ({
      ...state,
      search: payload.search,
      filters: payload.filters || initialState.filters,
      sorter: payload.sorter || initialState.sorter,
    }),

    startSaving: (state) => ({
      ...state,
      isSavingActive: true,
    }),
    finishSaving: (state) => ({
      ...state,
      isSavingActive: false,
    }),
    clearData: () => initialState,
  },
})

export default SEOPagesSlice
